module.exports = __webpack_public_path__ + "img/geografia.4e8d815a.svg";